import { createUseStyles } from 'react-jss'

import { LightTheme } from '../../../theme'

export const useStyle = createUseStyles((theme: LightTheme) => ({
  container: {
    background: theme.colors.white
  },
  filter: {
    marginLeft: 24
  },
  text: {
    whiteSpace: 'nowrap'
  },
  input: {
    '&:not(:first-child)': {
      marginLeft: 16
    }
  }
}))
